import React, { useEffect, useState } from "react";

import Header from "./header";
import Navbar from "./navbar";
import Banner from "./banner";

import CardUpDown from "./cardupdown";
import { dataListsType } from "./featured-posts";
import { DataLists } from "../dataLists/DataLists";

import AdPage from "./AdPage";
import Currency from "./currency";

const MobileVersion: React.FC = () => {
  const [featuredpostsOTData, setFeaturedpostsOTData] = useState<
    dataListsType[]
  >([]);
  const [featuredpostsOthersData, setFeaturedpostsOthersData] = useState<
    dataListsType[]
  >([]);

  const getFeaturedpostsAllData = () => {
    const randomData = [...DataLists].sort(() => 0.5 - Math.random());
    const data1 = randomData.slice(0, 2);
    const data2 = randomData.slice(2, 20);

    setFeaturedpostsOTData(data1);
    setFeaturedpostsOthersData(data2);
  };

  useEffect(() => {
    getFeaturedpostsAllData();
  }, []);

  return (
    <>
      <Header />
      <Navbar />
      <Banner />

      <AdPage />

      <Currency />

      <div className="w-full flex flex-col items-center p-8">
        <div className="w-full mb-8 border-b-[1px]">
          <h5 className="text-base font-semibold pt-2 pb-2 tracking-widest">
            FEATURED POSTS
          </h5>
          <span className="block w-14 h-[3px] bg-black"></span>
        </div>
        <div className="flex flex-col gap-y-7 mb-7">
          <CardUpDown props={featuredpostsOTData} />
        </div>

        <div id="ad_1">
          <AdPage />
        </div>

        <div className="flex flex-col gap-y-7 mb-7">
          <CardUpDown props={featuredpostsOthersData} />
        </div>
      </div>
    </>
  );
};

export default MobileVersion;
